(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thkr-launch"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-thkr-signup]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = form.querySelector('[role="status"]');
    const email = form.elements.email.value.trim();
    if (!form.reportValidity()) return;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = form.dataset.busy;
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
        method:'POST',
        headers:{'Content-Type':'application/vnd.api+json', 'revision':'2026-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'THKR password page launch signup',profile:{data:{type:'profile',attributes:{email:email,properties:{signup_source:'THKR password page'}}}}},relationships:{list:{data:{type:'list',id:form.dataset.list}}}}}),
        signal:AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Subscription request failed');
      status.textContent = form.dataset.success;
      form.reset();
    } catch (error) {
      status.textContent = form.dataset.error;
    } finally {
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
